import type CoachService from '@efdigital/ll-xceed-v2/services/coach';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';

export class IfCoach extends Component<{
  Blocks: {
    isCoach?: [];
    notCoach?: [];
  };
}> {
  @service declare coach: CoachService;

  get isCoach(): Promise<boolean> {
    return this.coach.isCoach();
  }

  <template>
    <Await @promise={{this.isCoach}}>
      <:success as |status|>
        {{#if status}}
          {{yield to="isCoach"}}
        {{else}}
          {{yield to="notCoach"}}
        {{/if}}
      </:success>
      <:error>
        {{yield to="notCoach"}}
      </:error>
    </Await>
  </template>
}
